import axiosConfig from '../axiosConfig';

export type TDocuments = {
	id: number;
	name: string;
	size: string;
	date: string;
	status: string;
	expires: string;
	action: React.ReactNode | null;
	file_path: string;
};

export class Documents implements TDocuments {
	id: number;
	name: string;
	size: string;
	date: string;
	status: string;
	expires: string;
	action: React.ReactNode | null;
	file_path: string;

	constructor(doc: TDocuments) {
		this.id = doc.id;
		this.name = doc.name;
		this.size = doc.size;
		this.date = doc.date;
		this.status = doc.status;
		this.expires = doc.expires;
		this.action = doc.action;
		this.file_path = doc.file_path;
	}

	public static Get(id: number): Promise<TDocuments> {
		return axiosConfig.instance.get(`app/document/${id}`).then((res) => {
			return new Documents(res.data as TDocuments);
		});
	}

	public static GetAll(): Promise<TDocuments[]> {
		return axiosConfig.instance.get('app/document').then((res) => {
			return ((res.data || []) as TDocuments[]).map((dateRange: TDocuments) => {
				return new Documents(dateRange);
			});
		});
	}

	public static Clear(id: number): Promise<TDocuments> {
		return axiosConfig.instance.delete(`app/document/${id}`).then((res) => {
			return new Documents(res.data as TDocuments);
		});
	}
}
